//JavaScript Document

import header from "./header";

export default {
	header
};
